
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/c/[slug]",
      function () {
        return require("private-next-pages/[locale]/c/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/c/[slug]"])
      });
    }
  